/**
 * Arthaus Related Dimensions
 * Phase: 6 → CDN hybrid (Phase C)
 *
 * Fetches the precomputed recommendations asset from the content CDN
 *   picasso.arthaus.cloud/content/recommendations/<handle>.json
 * and renders the concept/visual swim lanes from EMBEDDED card data — instant, and
 * with NO Shopify all_products cap. The "More from <artist>" lane is server-rendered
 * in Liquid, so it is skipped here (data-skip-artist) to avoid duplication.
 *
 * Cached shape:
 *   { version, source_handle, lanes: [ { key, label, kind, blurb, cards: [ { handle, title, artist, image } ] } ] }
 *
 * Progressive enhancement: any failure/empty response leaves the server-rendered
 * artist lane (and any native fallback grid) in place.
 */

(function () {
  'use strict';

  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function card(c) {
    if (!c.handle) return '';
    var href = '/products/' + c.handle;
    return '<a href="' + href + '" class="snap-start shrink-0 w-[200px] lg:w-[220px] group block">' +
        '<div class="aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-parchment">' +
          (c.image ? '<img src="' + esc(c.image) + '" alt="' + esc(c.title) + '" loading="lazy" width="220" height="293" class="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500">' : '') +
        '</div>' +
        '<h4 class="font-display text-base text-charcoal font-light truncate group-hover:text-bronze transition-colors">' + esc(c.title) + '</h4>' +
        (c.artist ? '<p class="font-body text-xs text-warm-gray truncate">' + esc(c.artist) + '</p>' : '') +
      '</a>';
  }

  function lane(l) {
    var cards = (l.cards || []).map(card).filter(Boolean).join('');
    if (!cards) return '';
    return '<div class="mb-12 lg:mb-16" data-lane data-lane-kind="' + esc(l.kind) + '">' +
        '<div class="flex items-baseline justify-between gap-4 mb-1.5">' +
          '<h3 class="font-display text-xl lg:text-2xl text-charcoal font-light tracking-tight">' + esc(l.label) + '</h3>' +
          '<span class="font-mono text-xs text-mute uppercase tracking-wider shrink-0">' + esc(l.kind) + '</span>' +
        '</div>' +
        (l.blurb ? '<p class="font-body text-sm text-warm-gray leading-relaxed mb-6 max-w-2xl">' + esc(l.blurb) + '</p>' : '<div class="mb-6"></div>') +
        '<div class="flex overflow-x-auto snap-x gap-5 lg:gap-6 pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">' + cards + '</div>' +
      '</div>';
  }

  function init() {
    var root = document.querySelector('[data-related-dimensions]');
    if (!root) return;
    var cdn = (root.getAttribute('data-cdn') || '').replace(/\/$/, '');
    var handle = root.getAttribute('data-handle');
    if (!cdn || !handle) return;
    var skipArtist = root.getAttribute('data-skip-artist') === 'true';
    var maxLanes = parseInt(root.getAttribute('data-max-lanes'), 10) || 4;

    fetch(cdn + '/' + encodeURIComponent(handle) + '.json', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cdn ' + r.status); return r.json(); })
      .then(function (d) {
        var lanes = (d && d.lanes || []).filter(function (l) {
          return !(skipArtist && (l.kind === 'Artist' || l.key === 'artist'));
        }).slice(0, maxLanes);
        var html = lanes.map(lane).filter(Boolean).join('');
        if (html) root.innerHTML = html; // replaces any native fallback grid
      })
      .catch(function () { /* keep the SSR artist lane + any fallback grid */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
